import { buildBoss } from 'game/raids/builders';

export const GrimBatol = buildBoss({
  id: 60670,
  name: 'Grim Batol',
});
